import {allowUserScroll, preventUserScroll} from '../../services/preventUserScroll';
import {elementInViewport} from '../../services/elementInViewport';
import {clickOnPremobileButton, open} from '../../../events/header';

/**
 * WARNING: all listeners set-up by this module MUST BE REMOVED by the returned destroy() function.
 */
Hop.defineModule('main-header-nav', (domRoot) => {
    const NAV_CLASSES = {
        opened: 'OPENED',
        invisible: 'INVISIBLE',
        hidden: 'hidden',
        mobileDropdownOpened: 'MOBILE-DROPDOWN-OPENED',
    };

    const domDataSubmenus = domRoot.querySelectorAll('[data-submenu]');
    const domCloseMenu = domRoot.querySelectorAll('[data-close-main-menu]');
    const domOpenMenu = domRoot.querySelector('[data-open-main-menu]');
    const domMainNavUL = domRoot.querySelector('[data-menu-list]');
    const domPremobileMenuButton = domRoot.querySelector('[data-open-premobile-menu]');
    const debounceResize = Hop.debounce(onResize, 50);

    function showMenuAndHideSearch() {
        Hop.events.trigger(clickOnPremobileButton);
    }

    function ensureProfilepictureIsDisplayed() {
        Hop.lazyLoad.update();
        closeSubMenusIfNavNotVisible();
    }

    function toggleMenu() {
        domRoot.classList.toggle(NAV_CLASSES.opened);
        domOpenMenu.classList.toggle(NAV_CLASSES.opened);

        const opened = domRoot.classList.contains(NAV_CLASSES.opened);

        if (opened) {
            preventUserScroll();
        } else {
            allowUserScroll();
        }

        if (domMainNavUL) {
            domMainNavUL.addEventListener('animationend', ensureProfilepictureIsDisplayed);
        }
    }

    function closeMenu() {
        allowUserScroll();

        domRoot.classList.remove(NAV_CLASSES.opened);
        domOpenMenu.classList.remove(NAV_CLASSES.opened);
    }

    function closeMobileNavIfDeviceDesktop() {
        if (window.innerWidth >= 1200 && domRoot.classList.contains('OPENED')) {
            closeMenu();
        }
    }

    function openSubmenu(submenu) {
        if (!submenu.hasAttribute('data-open-dropdown-submenu')) {
            closeAllSubMenus();
        }

        domRoot.classList.add(NAV_CLASSES.mobileDropdownOpened);
        submenu.classList.add(NAV_CLASSES.opened);
    }

    function closeSubMenu(submenu) {
        domRoot.classList.remove(NAV_CLASSES.mobileDropdownOpened);
        submenu.classList.remove(NAV_CLASSES.opened);
    }

    function toggleSubMenu(submenu) {
        if (submenu.classList.contains(NAV_CLASSES.opened)) {
            closeSubMenu(submenu);
        } else {
            openSubmenu(submenu);
        }
    }

    function closeAllSubMenus() {
        domDataSubmenus.forEach((submenu) => closeSubMenu(submenu));
    }

    function onResize() {
        closeSubMenusIfNavNotVisible();
        closeMobileNavIfDeviceDesktop();
    }

    function closeSubMenusIfNavNotVisible() {
        if (!elementInViewport(domRoot)) {
            closeAllSubMenus();
        }
    }

    function onClickSubmenu(e) {
        toggleSubMenu(e.currentTarget);
    }

    function undefinedCaseToCloseAllSubmenus(e) {
        // not sure to understand in which situations it occurs, but it occurs
        if (!e.target || !e.target.closest) {
            return;
        }
        if (!e.target.closest('[data-submenu], .main-header-nav__dropdown')) {
            closeAllSubMenus();
        }
    }

    function listenToUserActions() {
        domOpenMenu.addEventListener('click', toggleMenu);
        domCloseMenu.forEach((e) => e.addEventListener('click', closeMenu));
        domDataSubmenus.forEach((submenu) => submenu.addEventListener('click', onClickSubmenu));
        window.addEventListener('scroll', debounceResize);
        window.addEventListener('resize', debounceResize);
        document.addEventListener('click', undefinedCaseToCloseAllSubmenus);
        Hop.events.on(open, closeMenu);
    }

    function listenToHeaderEvents() {
        if (domPremobileMenuButton) {
            domPremobileMenuButton.addEventListener('click', showMenuAndHideSearch);
        }
    }

    listenToHeaderEvents();
    listenToUserActions();

    return function destroy() {
        if (domMainNavUL) {
            domMainNavUL.removeEventListener('animationend', ensureProfilepictureIsDisplayed);
        }
        domOpenMenu.removeEventListener('click', toggleMenu);
        domCloseMenu.forEach((e) => e.removeEventListener('click', closeMenu));
        domDataSubmenus.forEach((sm) => sm.removeEventListener('click', onClickSubmenu));
        if (domPremobileMenuButton) {
            domPremobileMenuButton.removeEventListener('click', showMenuAndHideSearch);
        }
        document.removeEventListener('click', undefinedCaseToCloseAllSubmenus);
        window.removeEventListener('scroll', debounceResize);
    };
});
